import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { HeaderContentSliderModule, HeaderUIUserModule, LinksColumnModule } from '@hdms/shared/page-frame/ui';
import { ButtonModule, PreloaderModule, ScrollbarModule, SvgIconModule } from '@hdms/shared/ui-core';
import { LetModule } from '@hdms/shared/util-core';

import { HeaderRegistrationButtonComponent } from '../../header-registration/header-registration-button.component';
import { HeaderUserAccountWrapperComponent } from '../../header-user-account-wrapper/header-user-account-wrapper.component';
import { HeaderUserLogoutComponent } from '../../header-user-logout/header-user-logout.component';

import { UserPopoverContentComponent } from './user-popover-content.component';

@NgModule({
  declarations: [UserPopoverContentComponent],
  imports: [
    CommonModule,
    TranslationModule,
    ButtonModule,
    SvgIconModule,
    ScrollbarModule,
    PreloaderModule,
    HeaderContentSliderModule,
    HeaderUIUserModule,
    LinksColumnModule,
    LetModule,
    HeaderRegistrationButtonComponent,
    HeaderUserAccountWrapperComponent,
    HeaderUserLogoutComponent
  ],
  exports: [UserPopoverContentComponent]
})
export class HeaderUserPopoverContentModule {}
